"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fp = _interopRequireDefault(require("lodash/fp"));
var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _icons = require("@material-ui/icons");
var _DrawerEntry = _interopRequireDefault(require("@fe/ui/Drawer/DrawerEntry"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
class DrawerMenuItem extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      open: false
    });
    _defineProperty(this, "toggleOpen", e => {
      this.setState(_fp.default.update('open', open => !open));
    });
  }
  render() {
    const accessibleRoutes = _fp.default.filter(r => !_fp.default.get(`${r}.role`, this.props.routeList) || _fp.default.includes(_fp.default.get(`${r}.role`, this.props.routeList), this.props.roles) || this.props.isAdmin, this.props.routes);
    if ((_fp.default.isEmpty(accessibleRoutes) || this.props.requiresAdmin && !this.props.isAdmin) && _fp.default.isEmpty(this.props.children)) {
      return false;
    }
    if (_fp.default.size(accessibleRoutes) === 1 && !this.props.children) {
      return /*#__PURE__*/_react.default.createElement(_DrawerEntry.default, {
        currentItemId: this.props.currentItemId,
        currentPath: this.props.currentPath,
        route: _fp.default.first(accessibleRoutes),
        icon: this.props.icon,
        routes: this.props.routeList,
        onClick: this.props.onClick
      });
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      button: true,
      onClick: this.toggleOpen
    }, /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, this.props.icon), /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
      inset: !this.props.icon,
      primary: this.props.name || '',
      primaryTypographyProps: {
        variant: 'subtitle1'
      }
    }), this.state.open ? /*#__PURE__*/_react.default.createElement(_icons.ExpandLess, null) : /*#__PURE__*/_react.default.createElement(_icons.ExpandMore, null)), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
      component: 'li',
      in: this.state.open,
      timeout: "auto",
      unmountOnExit: true
    }, /*#__PURE__*/_react.default.createElement(_List.default, {
      disablePadding: true
    }, this.props.children, _fp.default.map.convert({
      cap: false
    })((a, idx) => a === '-' ? /*#__PURE__*/_react.default.createElement(_Divider.default, {
      key: `${idx}${a}`
    }) : /*#__PURE__*/_react.default.createElement(_DrawerEntry.default, {
      key: `${idx}${a}`,
      currentItemId: this.props.currentItemId,
      currentPath: this.props.currentPath,
      route: a,
      routes: this.props.routeList,
      onClick: this.props.onClick
    }), accessibleRoutes))));
  }
}
_defineProperty(DrawerMenuItem, "propTypes", {
  name: _propTypes.default.string,
  icon: _propTypes.default.node,
  routes: _propTypes.default.array,
  roles: _propTypes.default.array.isRequired,
  currentItemId: _propTypes.default.any,
  currentPath: _propTypes.default.any,
  isAdmin: _propTypes.default.bool,
  requiresAdmin: _propTypes.default.bool,
  routeList: _propTypes.default.object.isRequired
});
_defineProperty(DrawerMenuItem, "defaultProps", {
  requiresAdmin: false
});
var _default = exports.default = DrawerMenuItem;